import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconLadderStyle0 = stylesCss;

const BiIconLadder$1 = /*@__PURE__*/ proxyCustomElement(class BiIconLadder extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: 'b6b4b94ea8314051c67b20c37c670daa1bcbab97', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '36425396d8b705cff5d90f5de5be738179308212', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'ac465bb999f43025991def20108c16699634d556', "fill-rule": 'evenodd', d: 'M6.372 22.549V2.578h1.5V6.57h9.983V2.578h1.5v19.97h-1.5v-3.993H7.872v3.994zm1.5-5.494h9.983v-3.742H7.872zm0-5.242h9.983V8.071H7.872z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconLadderStyle0; }
}, [1, "bi-icon-ladder", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-ladder"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-ladder":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconLadder$1);
            }
            break;
    } });
}

const BiIconLadder = BiIconLadder$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconLadder, defineCustomElement };
